import {inject, Pipe} from '@angular/core';
import {WithAsyncBase} from '@ng-dot/core';
import {TextActService} from './text-act.service';
import {TEXT_ACTINGS} from './text-actings';

@Pipe({
	name: 'act',
	pure: false
})
export class TextActPipe extends WithAsyncBase {
	protected _act = inject(TextActService);

	transform(target: string, acting: keyof typeof TEXT_ACTINGS, icon?: string): any {
		return this.transformWithAsync(arguments);
	}

	getValue(target: string, acting: keyof typeof TEXT_ACTINGS, icon?: string) {
		return this._act.get(target, acting, icon);
	}
}